let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dVMLi")).then(() => parcelRequire('foykc'));